import React from 'react';
import ItemListContainer from '../ItemListContainer/ItemListContainer';
import Portada from '../Portada/Portada';

const Main = () => {

  return (
    <div>
      <Portada/>
      <ItemListContainer/>
    </div>
  )
}

export default Main